export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-03.jpg'),
        title: 'APPLICATION OUTSOURCING',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: `THE CORE OF CUSTOMER’S LEGACY APPLICATIONS.`,
      description: `<p style="font-size:1.5rem">MaesInfo's software development services include application development and customized product development. Our developers focus on state-of-the-art technologies, as well as key technologies that are at the core of customer’s legacy applications. At MaesInfo, we focus on building applications using software components that reduce customer costs and development time. This combines with our strong management and communication processes to make us excellent outsourcing partners and help you achieve your specific goals.</p><p>Our Advantages：Identifying problems and finding the appropriate solutions You will know all costs and time scales in advance You will benefit from our latest systems, technology and process expertise No additional cost is required Flexibility of development sites More time to focus on your core business activities</p>`
    },
    {
      title: 'SCOPE OF SERVICE',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-03.jpg')+`)"></span>
      <span class="list">
        <i></i>Web Application Development </br>
        <i></i>Mobile Application Development</br>
        <i></i>Desktop Application Development</br>
        <i></i>Embedded Software Development</br>
        <i></i>Application of Data in Relational Database</br>
        <i></i>AJAX application</br>
        <i></i>Application of Business Process Automation
      </span>`
    }
  ]
}
